<template>
  <div class="teacher-display-board">
    <!-- <img class="avatar" src="https://lf26-cm.ecombdstatic.com/obj/temai/1f98ae54810ade242ab64da56092ea6dwww800-800" /> -->
    <img class="avatar" :src="teacherInfo.photo" />
    <div class="info-name">{{ teacherInfo.realname }}</div>
    <div class="info-stars">
      <img :src="require('@/assets/icon/star.png')" />
      <span>{{ teacherInfo.avgscore }}</span>
      <span class="reviews"
        >&nbsp; ({{ teacherInfo.teachminutes }} Minutes)</span
      >
    </div>
    <div class="num-of-student">
      <span>Number of students</span>
      <span>50+</span>
    </div>
    <div class="hourly-rate">
      <span>Hourly rate</span>
        <span>C$ {{(teacherInfo.price/100).toFixed(2)}}/h</span>
    </div>
    <div class="hourly-rate" v-if="userInfo.id != teacherInfo.id">
      <span>Contact Tutor</span>
      <span
        ><i
          class="el-icon-chat-dot-round"
          @click="contactPeople(teacherInfo.id)"
        ></i
      ></span>
    </div>
    <!-- <el-dialog
      :visible.sync="chatVisible"
      custom-class="chat-dialog"
      v-if="chatVisible"
      :append-to-body="true"
      :close-on-press-escape="true"
      :close-on-click-modal="false"
    >
      <VueChat></VueChat>
    </el-dialog> -->
    <slot></slot>
  </div>
</template>

<script>
import VueChat from "@/components/VueChat/index";
import { mapState } from "vuex";
export default {
  props: ["teacherInfo"],
  components: {
    VueChat,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.app.userInfo,
    }),
  },
  data() {
    return {
      chatVisible: false,
    };
  },
  methods: {
    contactPeople(id) {
      let routeData = this.$router.resolve({
        path: "/chat?contactId=" + id,
      });
      window.open(routeData.href, "_blank");
      //   this.chatVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.teacher-display-board {
  width: 100%;
  padding: vw(48) vw(32);
  box-sizing: border-box;
  box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
  border-radius: 24px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  transition: 0.2s;
  /deep/ .el-dialog {
    width: 1240px;
  }
  /deep/ .el-dialog__body {
    padding: 0 20px 30px 20px !important;
  }
  .avatar {
    width: vw(120);
    height: vw(120);
    border-radius: 16px;
  }
  .info-name {
    font-size: 22px;
    font-weight: 600;
    line-height: 24px;
    margin-top: 16px;
  }
  .num-of-student {
    margin-top: 32px;
  }
  .hourly-rate {
    margin-top: 12px;
  }
  .num-of-student,
  .hourly-rate {
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    span:nth-child(1) {
      color: #201002;
    }
    span:nth-child(2) {
      color: #f48c06;
    }
    .el-icon-chat-dot-round {
      cursor: pointer;
    }
  }
  .info-stars {
    margin-top: 12px;
    font-size: 14px;
    line-height: 20px;
    img {
      width: 12px;
      height: 12px;
      margin-right: 4px;
    }
    .reviews {
      color: #a6a6a6;
    }
  }
}
</style>